import { Receipt } from 'lucide-react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

export const HistoricalInvoicesFallback = () => {
  return (
    <Card className="bg-secondary p-0 gap-0">
      <CardHeader className="px-5 pt-3 pb-1">
        <CardTitle>
          <H3 className="flex items-center gap-2 text-sm text-muted-foreground">
            <Receipt className="size-4" /> Invoices
          </H3>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Card className="p-0 border-x-0 border-b-0 shadow-none">
          <CardContent className="pt-6 pb-6">
            <div className="flex flex-col gap-4">
              <div className="rounded-md border">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-muted/50 hover:bg-muted/50">
                      <TableHead>
                        <span className="pl-2">Number</span>
                      </TableHead>
                      <TableHead>Status</TableHead>
                      <TableHead>Created</TableHead>
                      <TableHead className="text-right">Amount</TableHead>
                      <TableHead></TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {Array.from({ length: 3 }).map((_, i) => (
                      <TableRow key={i}>
                        <TableCell className="py-2 m-0">
                          <Skeleton className="h-3 w-24" />
                        </TableCell>
                        <TableCell className="py-2 m-0">
                          <Skeleton className="h-3 w-24" />
                        </TableCell>
                        <TableCell className="py-2 m-0">
                          <Skeleton className="h-3 w-24" />
                        </TableCell>
                        <TableCell className="p-0 m-0 text-right items-end">
                          <Skeleton className="p-0 m-0 h-3 w-20 float-right" />
                        </TableCell>
                        <TableCell className="py-2 m-0">
                          <Skeleton className="h-3 w-16 float-right" />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  )
}
